// extracted by mini-css-extract-plugin
module.exports = {"header":"confirmModal_header__2hWK_","title":"confirmModal_title__zrlj3","withdraw":"confirmModal_withdraw__28f1L","proceed":"confirmModal_proceed__WhXNB"};